/* g-slider.js — slider nativo: frecce, stati, accessibilità. Nessun timer, nessun layout forzato. */
(function () {
  'use strict';
  var L = window.a11yLabels || {}; var t = function (k, d) { return L[k] || d; };
  var used = {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__gslider) return;
    var track = root.querySelector('.splide__track'); var list = root.querySelector('.splide__list');
    if (!track || !list) return;
    root.__gslider = true; root.classList.add('is-initialized');
    var prev = root.querySelector('.giunti-slider__arrow--prev, .splide__arrow--prev');
    var next = root.querySelector('.giunti-slider__arrow--next, .splide__arrow--next');

    // accessibilità: regione con nome, frecce etichettate
    if (!root.getAttribute('role')) { root.setAttribute('role', 'region'); root.setAttribute('aria-roledescription', t('carousel', 'Carosello')); }
    if (!root.getAttribute('aria-label')) {
      var wrap = root.closest('slider-component, .giunti-slider-container, .blog-related-products-banner, .featured-evidence-banner, .shopify-section, section');
      var sec = root.closest('.shopify-section, section');
      var h = (wrap && wrap.querySelector('h2')) || (sec && sec.querySelector('h2')) || (wrap && wrap.querySelector('h3'));
      var name = h ? h.textContent.trim().replace(/\s+/g, ' ').split('::')[0] : t('carousel', 'Carosello');
      used[name] = (used[name] || 0) + 1; if (used[name] > 1) name += ' (' + used[name] + ')';
      root.setAttribute('aria-label', name);
    }
    if (prev) { prev.type = 'button'; if (!prev.getAttribute('aria-label')) prev.setAttribute('aria-label', t('prev', 'Slide precedente')); }
    if (next) { next.type = 'button'; if (!next.getAttribute('aria-label')) next.setAttribute('aria-label', t('next', 'Slide successiva')); }
    list.setAttribute('role', 'presentation');

    function step() { return Math.max(track.clientWidth * 0.85, 100); }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(1); e.preventDefault(); } else if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
    });

    var raf = 0;
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      root.classList.toggle('is-overflow', overflow);
      if (prev) prev.disabled = !overflow || track.scrollLeft <= 1;
      if (next) next.disabled = !overflow || track.scrollLeft >= max - 1;
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    track.addEventListener('scroll', schedule, { passive: true });
    if (window.ResizeObserver) { var ro = new ResizeObserver(schedule); ro.observe(track); ro.observe(list); }
    else window.addEventListener('resize', schedule);
    // le copertine caricate dopo cambiano la larghezza: un solo aggiornamento per immagine, niente refresh dello slider
    // le copertine delle prime 6 slide si caricano subito (non durante lo swipe); decodifica fuori dal main thread
    list.querySelectorAll('.splide__slide').forEach(function (li, i) {
      li.querySelectorAll('img').forEach(function (img) {
        img.decoding = 'async';
        if (i < 6 && img.loading === 'lazy') img.loading = 'eager';
        if (!img.complete) img.addEventListener('load', schedule, { once: true });
      });
    });
    normalizeCards(list);
    update();
  }

  function normalizeCard(card) {
    if (card.__gcard) return; card.__gcard = true;
    var top = card.querySelector('.giunti-card__top'); var badges = card.querySelectorAll('.giunti-product-badges .giunti-badge');
    var kept = 0;
    badges.forEach(function (b) {
      var txt = b.textContent.trim().toUpperCase();
      if (b.classList.contains('giunti-discount-perc-badge')) { if (top && !top.querySelector('.g-badge-overlay')) { b.classList.add('g-badge-overlay'); top.appendChild(b); } else b.classList.add('g-badge-hidden'); return; }
      if (b.classList.contains('giunti-on-sale')) { b.classList.add('g-badge-hidden'); return; }
      var isState = b.classList.contains('giunti-not-available-product') || b.classList.contains('giunti-special-initiative-badge') || b.classList.contains('giunti-red-badge') || b.classList.contains('giunti-blue-badge') || /PRE ?ORDIN|PROSSIM|OUTLET|NOVIT/.test(txt);
      if (isState && kept < 1) { kept++; return; }
      b.classList.add('g-badge-hidden');
    });
    // skeleton: la copertina è pronta? + sfondo sfocato con la stessa immagine
    card.querySelectorAll('.giunti-card__media').forEach(function (m) {
      var img = m.querySelector('img');
      // (colore medio disattivato: box trasparente, copertina centrata)
      if (!img || (img.complete && img.naturalWidth > 0)) { m.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { m.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { m.classList.add('is-loaded'); }, { once: true });
    });
  }
  function setBg(el, img) {
    var src = img.currentSrc || img.src; if (!src) return;
    var cur = el.style.getPropertyValue('--g-bg');
    if (cur.indexOf(src) === -1) el.style.setProperty('--g-bg', 'url("' + src.replace(/"/g, '%22') + '")');
  }
  // Scheda prodotto, mobile: condividi e wishlist in alto a destra sulla copertina (da 640px tornano nella colonna info)
  var pdpMq = window.matchMedia ? window.matchMedia('(max-width: 639px)') : null;
  function pdpActions() {
    var w = document.querySelector('[data-g-pdp-actions]'); var gal = document.getElementById('main-carousel'); var home = document.querySelector('.g-cta-row--actions');
    if (!w || !gal || !home || !pdpMq) return;
    if (pdpMq.matches) { if (w.parentElement !== gal) { gal.appendChild(w); w.classList.add('g-pdp-actions'); } }
    else if (w.parentElement !== home) { home.appendChild(w); w.classList.remove('g-pdp-actions'); }
    if (!pdpActions.bound) { pdpActions.bound = true; if (pdpMq.addEventListener) pdpMq.addEventListener('change', pdpActions); else if (pdpMq.addListener) pdpMq.addListener(pdpActions); }
  }

  function galleryBg() {
    var gal = document.getElementById('main-carousel'); if (!gal) return;
    var sec = gal.closest('.shopify-section') || gal.parentElement; sec.classList.add('g-pdp');
    // sfondo sfocato: sempre la prima immagine del prodotto, anche quando si cambia slide (i cloni di Splide si saltano)
    var first = gal.querySelector('.splide__slide:not(.splide__slide--clone)') || gal.querySelector('.splide__slide');
    var img = first && first.querySelector('img'); if (!img) return;
    setBg(sec, img);
    var sr = sec.getBoundingClientRect(), gr = gal.getBoundingClientRect();
    sec.style.setProperty('--g-bg-top', Math.round(gr.top - sr.top) + 'px');
    sec.style.setProperty('--g-bg-h', Math.round(gr.height) + 'px');
    sec.style.setProperty('--g-bg-left', Math.round(gr.left - sr.left) + 'px');
    sec.style.setProperty('--g-bg-w', Math.round(gr.width) + 'px');
    if (!img.complete) img.addEventListener('load', function () { setBg(sec, img); }, { once: true });
    if (!gal.__gbgObs) { gal.__gbgObs = true; new MutationObserver(function () { galleryBg(); }).observe(gal, { subtree: true, attributes: true, attributeFilter: ['class'] }); window.addEventListener('resize', galleryBg); }
  }
  // colore medio della copertina (miniatura 40px, CORS ok su cdn.shopify.com) -> sfondo del box
  var colored = new WeakSet();
  function coverColor(media, img) {
    if (colored.has(media)) return; colored.add(media);
    var src = img.currentSrc || img.src; if (!src || !/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return;
    var small = src.replace(/([?&])width=\d+/, '$1width=40'); if (small === src) small += (src.indexOf('?') > -1 ? '&' : '?') + 'width=40';
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'), w = 8, h = 12; c.width = w; c.height = h; var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data, r = 0, g = 0, b = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { if (d[i + 3] < 200) continue; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
        if (!n) return; r = r / n; g = g / n; b = b / n;
        // schiarisco leggermente verso il bianco per non ingoiare la copertina
        var k = 0.22; r = r + (255 - r) * k; g = g + (255 - g) * k; b = b + (255 - b) * k;
        media.style.setProperty('--g-cover-bg', 'rgb(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ')'); media.classList.add('has-bg');
      } catch (e) {}
    };
    im.src = small;
  }
  // la copertina riempie il box (stesse proporzioni, tolleranza 4%)? allora niente sfondo colorato
  function fillsCheck(m, img) {
    var run = function () {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var bw = m.clientWidth, bh = m.clientHeight; if (!bw || !bh) return;
      var s = Math.min(bw / img.naturalWidth, bh / img.naturalHeight), w = img.naturalWidth * s, h = img.naturalHeight * s;
      m.classList.toggle('fills', w >= bw * 0.96 && h >= bh * 0.96);
    };
    if (img.complete) run(); else img.addEventListener('load', run, { once: true });
    window.addEventListener('resize', run);
  }
  function normalizeCards(root) { (root || document).querySelectorAll('.g-slider .product-card-wrapper .card, .splide .product-card-wrapper .card').forEach(normalizeCard); }

  function scan(root) { (root || document).querySelectorAll('.g-slider').forEach(init); normalizeCards(root); galleryBg(); pdpActions(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  new MutationObserver(function (ms) {
    ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('.g-slider')) init(n); if (n.querySelectorAll) scan(n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
